// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    FORGOT_PASSWORD: "/auth/forgot-password", // Add this
    RESET_PASSWORD: (token) => `/auth/reset-password/${token}`, // Add this
    USERS: "/users",
  },
  COURSES: {
    BASE: "/courses",
    INSTRUCTORS: (courseId) => `/courses/${courseId}/instructors`,
  },
  ATTENDANCE: {
    BASE: "/attendance",
    STUDENT: (studentId) => `/attendance/student/${studentId}`,
    COURSE: (courseId) => `/attendance/course/${courseId}`,
    COURSE_REPORT: (courseId) => `/attendance/course/${courseId}/report`,
  },
  STUDENTS: {
    BASE: "/students",
    ENROLLMENTS: (studentId) => `/students/${studentId}/enrollments`,
  },
  PAYMENTS: {
    BASE: "/payments",
    INVOICE: "/invoice",
    REFUND: (paymentId) => `/payments/${paymentId}/refund`,
    STUDENT: (studentId) => `/payments/student/${studentId}`,
  },
  CERTIFICATIONS: {
    BASE: "/certifications",
    GENERATE: (studentId, courseId) => `/certifications/generate/${studentId}/${courseId}`,
    VERIFY: (certificateNumber) => `/certifications/verify/${certificateNumber}`,
  },
};

// User roles
export const USER_ROLES = {
  ADMIN: "admin",
  INSTRUCTOR: "instructor",
  COORDINATOR: "coordinator",
  ACCOUNTANT: "accountant",
}

// Course status
export const COURSE_STATUS = {
  UPCOMING: "Upcoming",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
}

// Student status
export const STUDENT_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  GRADUATED: "Graduated",
  DROPPED: "Dropped",
}

export const PAYMENT_STATUS = {
  PAID: "Paid",
  PENDING: "Pending",
  PARTIAL: "Partial",
  REFUNDED: "Refunded",
  CANCELLED: "Cancelled",
}

// Payment methods
export const PAYMENT_METHODS = ["PayPal", "Stripe", "Bank Transfer", "Cash", "Chapa", "Other"]

// Certificate status
export const CERTIFICATIONS = {
  BASE: "/certifications", // Update to match the backend route
  GENERATE: (studentId, courseId) => `/certifications/generate/${studentId}/${courseId}`,
  VERIFY: (certificateNumber) => `/certifications/verify/${certificateNumber}`,
};